import { create } from "zustand";

export const useAssessmentStore = create((set) => ({
  // State
  assessments: [],
  questions: [], // For specific assessment
  assessmentQuestions: [], // For document list
  loading: false,
  error: null,
  searchQuery: "",
  sortBy: null,
  sortDirection: null,
  filters: {},
  pagination: {
    currentPage: 1,
    itemsPerPage: 10,
    totalItems: 0,
    totalPages: 1,
    hasNextPage: false,
    hasPreviousPage: false,
  },
  isDetailDialogOpen: false,
  assessmentToView: null,
  // Column filters & unique values
  columnFilters: {},
  uniqueValues: {},

  // Assessment Questions specific state
  questionSearchQuery: "",
  questionSortBy: null,
  questionSortDirection: null,
  questionFilters: {},
  questionPagination: {
    currentPage: 1,
    itemsPerPage: 10,
    totalItems: 0,
    totalPages: 1,
    hasNextPage: false,
    hasPreviousPage: false,
  },
  questionColumnFilters: {},
  questionUniqueValues: {},
  isQuestionDetailDialogOpen: false,
  questionToView: null,

  // Calendar specific state
  calendarData: {
    assessments: [],
    questions: [],
  },
  calendarLoading: false,
  calendarError: null,

  // Actions (Setters)
  setAssessments: (assessments) => set({ assessments }),
  setQuestions: (questions) => set({ questions }),
  setAssessmentQuestions: (assessmentQuestions) => set({ assessmentQuestions }),

  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
  clearError: () => set({ error: null }),

  setSearchQuery: (query) => set({ searchQuery: query }),
  setSort: (sortBy, sortDirection) => set({ sortBy, sortDirection }),
  setFilters: (newFilters) => set((state) => ({ filters: { ...state.filters, ...newFilters } })),
  setPagination: (pagination) => set(state => ({ pagination: { ...state.pagination, ...pagination } })),
  setColumnFilters: (columnFilters) => set({ columnFilters }),
  setUniqueValues: (uniqueValues) => set({ uniqueValues }),

  openDetailDialog: (assessment) => set({
    isDetailDialogOpen: true,
    assessmentToView: assessment
  }),

  closeDetailDialog: () => set({
    isDetailDialogOpen: false,
    assessmentToView: null
  }),

  setQuestionSearchQuery: (query) => set({ questionSearchQuery: query }),
  setQuestionSort: (sortBy, sortDirection) => set({ questionSortBy: sortBy, questionSortDirection: sortDirection }),
  setQuestionFilters: (newFilters) => set((state) => ({ questionFilters: { ...state.questionFilters, ...newFilters } })),
  setQuestionPagination: (pagination) => set(state => ({ questionPagination: { ...state.questionPagination, ...pagination } })),
  setQuestionColumnFilters: (columnFilters) => set({ questionColumnFilters: columnFilters }),
  setQuestionUniqueValues: (uniqueValues) => set({ questionUniqueValues: uniqueValues }),

  openQuestionDetailDialog: (question) => set({
    isQuestionDetailDialogOpen: true,
    questionToView: question
  }),

  closeQuestionDetailDialog: () => set({
    isQuestionDetailDialogOpen: false,
    questionToView: null
  }),

  setCalendarData: (data) => set({ calendarData: data }),
  setCalendarLoading: (loading) => set({ calendarLoading: loading }),
  setCalendarError: (error) => set({ calendarError: error }),
}));
